import { Typography, useViewport } from '@lamimed/pantheon';
import Image from 'next/legacy/image';
import rehypeRaw from 'rehype-raw';
import remarkBreaks from 'remark-breaks';

import { Category } from 'models/Category';

import { MainCallToAction } from 'components/MainCallToAction';
import TextWrapper from 'components/TextWrapper';

import * as S from './styles';

interface Props {
  categoryData: Category;
}

export const CategoryHeader: React.FC<Props> = ({ categoryData }) => {
  const { greaterThan } = useViewport();

  return (
    <MainCallToAction as="header">
      <S.ImageContainer>
        <Image
          src={`/images/illustration/categories/${categoryData?.slug}.png`}
          alt={categoryData?.slug}
          width={320}
          height={270}
          quality={100}
        />
      </S.ImageContainer>

      <TextWrapper textAlign="left" noMargin>
        <S.TextContainer>
          <Typography
            marginTop={greaterThan('tablet') ? 'none' : 'large'}
            marginBottom="small"
            variant={greaterThan('tablet') ? 'heading_display' : 'heading_1'}
            color="text__highlight"
            as="h1"
          >
            {categoryData?.title}
          </Typography>

          <S.ReactMarkdown
            remarkPlugins={[remarkBreaks]}
            rehypePlugins={[rehypeRaw]}
          >
            {categoryData?.formattedDescription}
          </S.ReactMarkdown>
        </S.TextContainer>
      </TextWrapper>
    </MainCallToAction>
  );
};
